module.exports = __webpack_public_path__ + "img/wxpayinactive.11cf2f74.png";